import ClassNames from "classnames";

// Shared button styles for Button and IconButton (mirrors main's `sharedProps`
// PropTypes `oneOf` list). The PropTypes runtime shape object is intentionally
// dropped in the TS conversion — no consumer imports it.
export const buttonStyles = [
  "default",
  "danger",
  "primary",
  "secondary",
  "textLink",
  "invert",
  "ai",
  "ai-outline",
  "ai-inverted",
  "warning",
  "menu",
] as const;

export type ButtonStyle = (typeof buttonStyles)[number];

// Subset of button props read by generateClassNameWrapper to build class names.
export interface SharedButtonClassNameProps {
  wrapperClassName?: string;
  disabled?: boolean;
  isFullWidth?: boolean;
  isSubmitting?: boolean;
  // `false` is tolerated at runtime (callers pass `cond && "style"`); falsy
  // values simply add no is-* class.
  buttonStyle?: ButtonStyle | "" | false;
}

// Utility function to generate class names
export const generateClassNameWrapper = (
  sharedProps: SharedButtonClassNameProps,
  specificProps: ClassNames.Argument
): string => {
  const sharedClassNames = {
    [`${sharedProps.wrapperClassName}`]: sharedProps.wrapperClassName,
    "is-disabled": sharedProps.disabled,
    "is-fullwidth": sharedProps.isFullWidth,
    "is-submitting": sharedProps.isSubmitting,
    [`is-${sharedProps.buttonStyle || ""}`]: sharedProps.buttonStyle || "",
  };

  // Combine shared and specific class names
  const classNames = ClassNames(sharedClassNames, specificProps);

  return classNames;
};

export const actionStates = {
  IDLE: "idle",
  ERROR: "error",
  SUBMITTING: "submitting",
  SUCCESS: "success",
} as const;

export type ActionState = (typeof actionStates)[keyof typeof actionStates];
